export const copyMixin = {
  methods: {
    copyMixin(selector, successText) {
      let testingCodeToCopy = document.querySelector(selector)
      testingCodeToCopy && testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy && testingCodeToCopy.select()
      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        this.$notification.info(successText + msg);
      } catch(err) {
        this.$notification.error('Oops, unable to copy');
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  }
}
